import { Component } from '@angular/core';

@Component({
  selector: 'vpfa-modal-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponent {}
